;(function () {
  'use strict'

  angular
    .module('contrast.application.coverage')
    .controller(
      'AppCoverageStatsCtrl',
      function (
        $scope,
        $routeSegment,
        $routeParams,
        $interval,
        ApplicationFactory,
        ErrorService,
        REFRESH_DELAY
      ) {
        'ngInject'

        var _appId, _weekStart, _weekEnd, _intervalPromise

        function init() {
          _setDefaults()

          if (
            $routeSegment.startsWith(
              $routeSegment.name,
              'appDashboard.coverage'
            )
          ) {
            load().then(_startInterval)
          }

          $scope.$on('$destroy', _destroy)
        }

        function _destroy() {
          if (_intervalPromise) {
            $interval.cancel(_intervalPromise)
          }
        }

        function _setDefaults() {
          _appId = $routeParams.appId
          _weekStart = new Date()
          _weekStart.setDate(_weekStart.getDate() - 7)
          _weekEnd = new Date()

          angular.extend($scope, {
            stats: {
              start: _weekStart.getTime(),
              end: _weekEnd.getTime(),
              total_uri: 0,
              total_queries: 0,
              total_http_calls: 0,
              total_vulnerabilities: 0
            }
          })
        }

        function _startInterval() {
          _intervalPromise = $interval(load, REFRESH_DELAY.mediumDelay, 1)
        }

        function load() {
          return _getLastWeekCoverageStats().then(function (stats) {
            angular.extend($scope.stats, {
              total_uri: stats.uris,
              total_queries: stats.queries,
              total_http_calls: stats.http_calls,
              total_vulnerabilities: stats.traces
            })
          })
        }

        function _getLastWeekCoverageStats() {
          return ApplicationFactory.getLastWeekCoverageStats(_appId)
            .then(function (response) {
              return response.data
            })
            .catch(ErrorService.processError)
        }

        init()
      }
    )
})()
